import { useSelector } from "react-redux";
import { sendTrackingEvent, currentUserGroupIdSelector, currentSharedMailBoxIdSelector } from "h-commons";

/**
 * Utility hook for sending gainsight events used in product-led growth (PLG) initiatives.
 * Returns a function that can be called to send an event with default property as typeUgIdInboxId.
 */
const useSmGainsightEvent = () => {
    const userGroupId = useSelector(currentUserGroupIdSelector);
    const smId = useSelector(currentSharedMailBoxIdSelector)
    /**
     * @param {Number} inboxId
     * @param {String} eventName
     * @param {Object} eventProps
     * @param {String} inboxType Eg: Email, Chat, Voice or WhatsApp
     */
    const sendGSEvent = ({ inboxId, eventName, eventProps = {}, inboxType = "Email" }) => {
        sendTrackingEvent(eventName, {
            typeUgIdInboxId: `${inboxType}_${userGroupId}_${inboxId || smId}`,
            ...eventProps
        });
    };

    return { sendGSEvent };
}

export { useSmGainsightEvent }
